import React from 'react';
import { Box, TextField, Typography } from '@mui/material';

interface GrowthSimulationProps {
  percentageValue: number | string;
  setPercentageValue: (value: number | string) => void;
}

const GrowthSimulation: React.FC<GrowthSimulationProps> = ({
  percentageValue,
  setPercentageValue,
}) => {
  return (
    <Box gap={2} display='flex' justifyContent='flex-end' alignItems='center'>
      <Typography variant='body2' fontWeight={'bold'} color='text.secondary'>
        Simulación de crecimiento:
      </Typography>
      <TextField
        type='number'
        variant='outlined'
        size='small'
        sx={{ width: 100 }}
        InputProps={{
          endAdornment: <span>%</span>,
          inputProps: {
            min: 0,
            max: 100,
            step: 1,
          },
          sx: {
            '& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button':
              {
                WebkitAppearance: 'none',
                margin: 0,
              },
            '& input[type=number]': {
              MozAppearance: 'textfield',
            },
          },
        }}
        value={percentageValue}
        onChange={e => setPercentageValue(e.target.value)}
      />
    </Box>
  );
};

export default GrowthSimulation;
